// Canonical deliverable vocabulary — MUST stay in sync with the CRM's
// `DELIVERABLE_TYPES` in `apps/shell/src/lib/crm/suppliersPresenter.ts`.
//
// Why this file exists: a campaign's requirements cross the wire between this
// site and the CRM in both directions. The two sides used to disagree — the
// CRM stored the type as free text, this site offered a fixed four-option
// <select>. A <select> whose `value` matches none of its options renders as
// the FIRST option, so anything the CRM sent that wasn't exactly one of the
// four — a `tiktok`, a legacy "סטורי", an "IG story" — displayed as "ריל",
// and the next save wrote that back. That is the "I mark story, management
// shows reels" report.
//
// Keys are ASCII because they are stored and transmitted; Hebrew is display
// only. If you add a type here, add it to the CRM list in the same change.

export const DELIVERABLE_TYPES = ['reel', 'story', 'post', 'tiktok', 'video'];

export const DELIVERABLE_TYPE_HE = {
  reel: 'ריל',
  story: 'סטורי',
  post: 'פוסט',
  tiktok: 'טיקטוק',
  video: 'וידאו',
};

// Legacy free-text values seen in the data, folded onto a canonical key.
const ALIASES = {
  reel: 'reel', reels: 'reel', 'ig reel': 'reel', ריל: 'reel', רילס: 'reel',
  story: 'story', stories: 'story', 'ig story': 'story', סטורי: 'story', סטוריז: 'story',
  post: 'post', posts: 'post', פוסט: 'post', פוסטים: 'post',
  tiktok: 'tiktok', 'tik tok': 'tiktok', טיקטוק: 'tiktok',
  video: 'video', וידאו: 'video', סרטון: 'video',
};

/**
 * Fold a raw value onto a canonical key, or null when nothing matches.
 * Returning null rather than guessing is the point: an unrecognised value
 * must stay visible as itself, never be silently relabelled.
 */
export function canonicalDeliverableType(raw) {
  if (!raw) return null;
  return ALIASES[String(raw).trim().toLowerCase()] ?? null;
}

/** Hebrew label when we recognise the value, the raw value otherwise. */
export function deliverableTypeLabel(raw) {
  const key = canonicalDeliverableType(raw);
  return key ? DELIVERABLE_TYPE_HE[key] : raw;
}
